/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const createProposedItemRequestSchema = z.object({
  itemTypeId: z.int().nullish(),
  parentId: z.int().nullish(),
  sortOrder: z.optional(z.int()),
  title: z.string(),
});
